import Router from 'vue-router';

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      redirect: '/launchApplication',
    },
    {
      path: '/error',
      component: require('./views/ErrorPage').default,
      name: 'error',
    },
    {
      path: '/createApplication',
      name: 'createApplication',
      component: require('./views/launchApplication/CreateApplication').default,
      meta: {
        matchNav: 'launchApplication',
      },
    },
    {
      path: '/createReimbursement',
      name: 'createReimbursement',
      component: require('./views/launchApplication/CreateReimbursement').default,
      meta: {
        matchNav: 'launchApplication',
      },
    },
    {
      path: '/createBudgetApplication',
      name: 'createBudgetApplication',
      component: require('./views/launchApplication/CreateBudgetApplication').default,
      meta: {
        matchNav: 'launchApplication',
      },
    },
    {
      path: '/createPurchase',
      name: 'createPurchase',
      component: require('./views/launchApplication/CreatePurchase').default,
      meta: {
        matchNav: 'launchApplication',
      },
    },
    {
      path: '/myApplicationDetail',
      name: 'myApplicationDetail',
      component: require('./views/myApplication/MyApplicationDeatil').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    },
    {
      path: '/myApplicationDetailEdit',
      name: 'myApplicationDetailEdit',
      component: require('./views/myApplication/MyApplicationDeatilEdit').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    },
    {
      path: '/myReimbursementDetail',
      name: 'myReimbursementDetail',
      component: require('./views/myApplication/MyReimbursementDetail').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    },
    {
      path: '/myReimbursementDetailEdit',
      name: 'myReimbursementDetailEdit',
      component: require('./views/myApplication/MyReimbursementDetailEdit').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    },
    {
      path: '/myBudgetApplicationDetail',
      name: 'myBudgetApplicationDetail',
      component: require('./views/myApplication/MyBudgetApplicationDetail').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    }, {
      path: '/myPurchaseDetail',
      name: 'myPurchaseDetail',
      component: require('./views/myApplication/MyPurchaseDetail').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    }, {
      path: '/myBudgetApplicationDetailEdit',
      name: 'myBudgetApplicationDetailEdit',
      component: require('./views/myApplication/MyBudgetApplicationDetailEdit').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    }, {
      path: '/myPurchaseDetailEdit',
      name: 'myPurchaseDetailEdit',
      component: require('./views/myApplication/MyPurchaseDetailEdit').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    },
    {
      path: '/waitApprovalDetail',
      name: 'waitApprovalDetail',
      component: require('./views/waitApproval/WaitApprovalDetail').default,
      meta: {
        matchNav: 'waitApprovalList',
      },
    },
    {
      path: '/waitReimbursementDetail',
      name: 'waitReimbursementDetail',
      component: require('./views/waitApproval/WaitReimbursementDetail').default,
      meta: {
        matchNav: 'waitApprovalList',
      },
    }, {
      path: '/waitPurchaseDetail',
      name: 'waitPurchaseDetail',
      component: require('./views/waitApproval/WaitPurchaseDetail').default,
      meta: {
        matchNav: 'waitApprovalList',
      },
    },
    {
      path: '/waitBudgetApplicationDetail',
      name: 'waitBudgetApplicationDetail',
      component: require('./views/waitApproval/WaitBudgetApplicationDetail').default,
      meta: {
        matchNav: 'waitApprovalList',
      },
    },
    {
      path: '/waitCommonDetail',
      name: 'waitCommonDetail',
      component: require('./views/waitApproval/WaitCommonDetail').default,
      meta: {
        matchNav: 'waitApprovalList',
      },
    },
    {
      path: '/approvedByMeDetail',
      name: 'approvedByMeDetail',
      component: require('./views/approvedByMe/ApprovedByMeDetail').default,
      meta: {
        matchNav: 'approvedByMeList',
      },
    }, {
      path: '/approvedReimbursementDetail',
      name: 'approvedReimbursementDetail',
      component: require('./views/approvedByMe/ApprovedReimbursementDetail').default,
      meta: {
        matchNav: 'approvedByMeList',
      },
    }, {
      path: '/approvedBudgetApplicationDetail',
      name: 'approvedBudgetApplicationDetail',
      component: require('./views/approvedByMe/ApprovedBudgetApplicationDetail').default,
      meta: {
        matchNav: 'approvedByMeList',
      },
    }, {
      path: '/approvedPurchaseDetail',
      name: 'approvedPurchaseDetail',
      component: require('./views/approvedByMe/ApprovedPurchaseDetail').default,
      meta: {
        matchNav: 'approvedByMeList',
      },
    },
    {
      path: '/createProExpendReimbursement',
      name: 'createProExpendReimbursement',
      component: require('./views/launchApplication/CreateProExpendReimbursement').default,
      meta: {
        matchNav: 'launchApplication',
      },
    },
    {
      path: '/myProExpendReimbursementDetail',
      name: 'myProExpendReimbursementDetail',
      component: require('./views/myApplication/MyProExpendReimbursementDetail').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    },
    {
      path: '/myProExpendReimbursementDetailEdit',
      name: 'myProExpendReimbursementDetailEdit',
      component: require('./views/myApplication/MyProExpendReimbursementDetailEdit').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    },
    {
      path: '/waitProExpendReimbursementDetail',
      name: 'waitProExpendReimbursementDetail',
      component: require('./views/waitApproval/WaitProExpendReimbursementDetail').default,
      meta: {
        matchNav: 'waitApprovalList',
      },
    },
    {
      path: '/approvedProExpendReimbursementDetail',
      name: 'approvedProExpendReimbursementDetail',
      component: require('./views/approvedByMe/ApprovedProExpendReimbursementDetail').default,
      meta: {
        matchNav: 'approvedByMeList',
      },
    },
    {
      path: '/createProExpendPayment',
      name: 'createProExpendPayment',
      component: require('./views/launchApplication/CreateProExpendPayment').default,
      meta: {
        matchNav: 'launchApplication',
      },
    },
    {
      path: '/myProExpendPaymentDetail',
      name: 'myProExpendPaymentDetail',
      component: require('./views/myApplication/MyProExpendPaymentDetail').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    },
    {
      path: '/myProExpendPaymentDetailEdit',
      name: 'myProExpendPaymentDetailEdit',
      component: require('./views/myApplication/MyProExpendPaymentDetailEdit').default,
      meta: {
        matchNav: 'myApplicationList',
      },
    },
    {
      path: '/waitProExpendPaymentDetail',
      name: 'waitProExpendPaymentDetail',
      component: require('./views/waitApproval/WaitProExpendPaymentDetail').default,
      meta: {
        matchNav: 'waitApprovalList',
      },
    },
    {
      path: '/approvedProExpendPaymentDetail',
      name: 'approvedProExpendPaymentDetail',
      component: require('./views/approvedByMe/ApprovedProExpendPaymentDetail').default,
      meta: {
        matchNav: 'approvedByMeList',
      },
    },

    require('./views/launchApplication').route,
    require('./views/myApplication').route,
    require('./views/waitApproval').route,
    require('./views/approvedByMe').route,
  ],
});

const navMenus = [{
  title: '发起申请',
  icon: 'SvgIcPlus',
  key: 'launchApplication',
  to: {
    name: 'launchApplication'
  },
}, {
  title: '我的申请',
  icon: 'SvgIcSendMessageo',
  key: 'myApplicationList',
  to: {
    name: 'myApplicationList'
  },
}, {
  title: '待我审批',
  icon: 'SvgIcAudit',
  key: 'waitApprovalList',
  to: {
    name: 'waitApprovalList'
  },
}, {
  title: '我已审批',
  icon: 'SvgIcCheckSquare',
  key: 'approvedByMeList',
  to: {
    name: 'approvedByMeList'
  },
}];

export {
  Router,
  router,
  navMenus
};